import { PageType } from '../../types/domain.types';
import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const updatePage = (page: PageType) =>
  api.put(`/pages/${page.page_id}`, { ...page });

export const useUpdatePageMutation = () => {
  return useMutation({
    mutationKey: ['updatePage'],
    mutationFn: updatePage,
  });
};
